import { Flex } from '@components';
import { styled } from '@mui/material';

export const CategoryContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(8),
  padding: theme.spacing(10, 0),
}));

export const NewItemFormContainer = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(12, 16),
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(8),
  gap: theme.spacing(12),
}));
